import React from 'react';
import styled from 'styled-components';
import useGetIncompatibleParts from 'hooks/useGetIncompatibleParts';
import ui from 'config-app/ui';

const Component = ({ variants, products, selectedId, onClick }) => {
  const lidList = window.CB.Lid
  return (
    <Container>
      <Options>
        <div className="inner">
          {variants.map((id, index) => {
            let outOfStock = false;
            const selectedItem = lidList.products[id];
            const inventoryPolicy = selectedItem.inventory_policy;
            const inventoryQuantity = selectedItem.inventory_quantity;
            if (inventoryQuantity <= 0 && inventoryPolicy === "deny") {
              outOfStock = true;
            }
            return (
              <PartsItem
                key={index}
                id={id}
                selected={selectedId === id}
                image={products[id].image}
                label={products[id].name}
                onClick={onClick}
                outOfStock={outOfStock}
              />
            );
          })}
        </div>
      </Options>
    </Container>
  );
};

const PartsItem = ({outOfStock, id, image, selected, onClick }) => {
  const disabled = useGetIncompatibleParts(id);
  if (!disabled) {
    return (
      <Item
        image={image}
        selected={selected}
        onClick={() => onClick(id)}
        disabled={outOfStock && "disabled"}
      >
        <div className="imageFrame">
          <div className="image" />
        </div>
      </Item>
    );
  } else {
    return null;
  }
};

export default Component;

const Container = styled.div`
  ${ui.MQ_MD_LG} {
    margin-top: 20px;
  }

  ${ui.MQ_XS_SM} {
    margin-left: -30px;
    margin-top: 16px;
  }
`;

const Options = styled.div`
  &::-webkit-scrollbar {
    display: none;
  }
  ${ui.MQ_XS_SM} {
    margin-right: -25px;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .inner {
    ${ui.MQ_XS_SM} {
      white-space: nowrap;
      overflow-x: auto;
      width: 100vw;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    ${ui.MQ_MD_LG} {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
`;

const Item = styled.div`
  cursor: pointer;
  &[disabled] {
    .imageFrame::after {
      display: block;
      position: absolute;
      content: '';
      height: 0;
      border-bottom: 3px rgba(136,136,136,.2) solid;
      width: 200px;
      transform: rotate(-45deg);
      transform-origin: left top;
      left: -1px;
      top: auto;
      bottom: auto
    }
  }

  ${ui.MQ_XS_SM} {
    display: inline-block;
    width: 100px;
    vertical-align: top;

    &:first-child {
      margin-left: 30px;
    }

    &:not:first-child {
      margin-left: 15px;
    }

    &:last-child {
      margin-right: 25px;
    }
  }

  ${ui.MQ_MD_LG} {
    flex-shrink: 0;
    flex-basis: 100px;
    max-width: 100px;
    min-width: 0;
    margin-bottom: 20px;
  }

  .imageFrame {
    position: relative;
    height: 80px;
    width: 80px;
    margin-right: 20px;
    box-sizing: border-box;
    border: ${(props) => (props.selected ? '3px solid #333333' : '1px solid #D7D7D7')};
    overflow: hidden;
  }

  .image {
    width: 100%;
    height: 100%;
    background: no-repeat 50% 50%;
    background-image: url(${(props) => props.image});
    background-size: 80px;
    background-position: center center;
    opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  }
`;
